/**
 * Очередь записей в Bitrix (`GET /api/bitrix/commands`): правки сделки, лида и создание сделки, на
 * которые Bitrix не ответил, — их досылает сервер каждые 20 с. Не дошло за 10 минут или в Bitrix уже
 * поменяли — «Повторить» (`POST …/{id}/retry`) или «Отменить» (`POST …/{id}/cancel`).
 * Спека `docs/specs/2026-10-22-bitrix-outbox-design.md`.
 */
import { apiFetch } from "@/lib/api";

/** queued / sending — ждёт досылки; done — дошло после сбоя; conflict, expired, error — не дошло. */
export type CommandState = "queued" | "sending" | "done" | "conflict" | "expired" | "error" | "cancelled";
export type BitrixCommand = {
  id: number;
  method: string;
  entity: string;
  entity_id: number | null;
  chat_id: number | null;
  /** Что за правка — строка журнала (««Чаты»: стадия Думают — Орлова Нина»). */
  what: string;
  state: CommandState;
  attempts: number;
  /** UTC с `Z`. */
  next_at: string | null;
  created: string | null;
  error: string;
};
export type CommandTarget = { deal?: number | null | undefined; lead?: number | null | undefined; chat?: number | null | undefined };

export const isWaiting = (c: BitrixCommand) => c.state === "queued" || c.state === "sending";

export const loadCommands = (t: CommandTarget) => {
  const q = new URLSearchParams();
  if (t.deal) q.set("deal", String(t.deal));
  if (t.lead) q.set("lead", String(t.lead));
  if (t.chat) q.set("chat", String(t.chat));
  return apiFetch<BitrixCommand[]>(`/api/bitrix/commands?${q}`);
};

export const retryCommand = (id: number) =>
  apiFetch<BitrixCommand>(`/api/bitrix/commands/${id}/retry`, { method: "POST" });

export const cancelCommand = (id: number) =>
  apiFetch<BitrixCommand>(`/api/bitrix/commands/${id}/cancel`, { method: "POST" });
